/**
 * action types
 */
export const SET_PORTAL_DATA = 'SET_PORTAL_DATA';
export const SET_PORTAL_PAGE_SECTION_TYPES = 'SET_PORTAL_PAGE_SECTION_TYPES';
export const SET_PORTAL_FAQS = 'SET_PORTAL_FAQS';
export const START_SAVE_PORTAL_FAQS = 'START_SAVE_PORTAL_FAQS';
export const FINISH_SAVE_PORTAL_FAQS = 'FINISH_SAVE_PORTAL_FAQS';
export const SET_PORTAL_FOOTER = 'SET_PORTAL_FOOTER';
export const START_SAVE_PORTAL_FOOTER = 'START_SAVE_PORTAL_FOOTER';
export const FINISH_SAVE_PORTAL_FOOTER = 'FINISH_SAVE_PORTAL_FOOTER';
export const SET_PORTAL_PAGE_SECTIONS = 'SET_PORTAL_PAGE_SECTIONS';
export const START_SAVE_PORTAL_PAGE_SECTIONS =
  'START_SAVE_PORTAL_PAGE_SECTIONS';
export const FINISH_SAVE_PORTAL_PAGE_SECTIONS =
  'FINISH_SAVE_PORTAL_PAGE_SECTIONS';
export const SET_PORTAL_SELLING_POINTS = 'SET_PORTAL_SELLING_POINTS';
export const START_SAVE_PORTAL_SELLING_POINTS =
  'START_SAVE_PORTAL_SELLING_POINTS';
export const FINISH_SAVE_PORTAL_SELLING_POINTS =
  'FINISH_SAVE_PORTAL_SELLING_POINTS';
export const SET_PORTAL_COURSE_CATEGORIES = 'SET_PORTAL_COURSE_CATEGORIES';
export const FINISH_SAVE_PORTAL_MEDIA = 'FINISH_SAVE_PORTAL_MEDIA';
export const FINISH_SAVE_PORTAL_LANDING_PAGE =
  'FINISH_SAVE_PORTAL_LANDING_PAGE';
export const SET_PORTAL_NAV_BAR_LINKS = 'SET_PORTAL_NAV_BAR_LINKS';
export const FINISH_SAVE_PORTAL_BRANDING = 'FINISH_SAVE_PORTAL_BRANDING';
export const SET_PORTAL_QUALIFICATION_PAGE_SECTIONS =
  'SET_PORTAL_QUALIFICATION_PAGE_SECTIONS';
export const FINISH_SAVE_PORTAL_QUALIFICATION_PAGE_SECTIONS =
  'FINISH_SAVE_PORTAL_QUALIFICATION_PAGE_SECTIONS';
export const SET_PORTAL_QUALIFICATION_NAV_BAR_LINKS =
  'SET_PORTAL_QUALIFICATION_NAV_BAR_LINKS';
export const SET_PORTAL_QUALIFICATION_TEMPLATES =
  'SET_PORTAL_QUALIFICATION_TEMPLATES';
export const START_SAVE_PORTAL_QUALIFICATION_LANDING_PAGE =
  'START_SAVE_PORTAL_QUALIFICATION_LANDING_PAGE';
export const FINISH_SAVE_PORTAL_QUALIFICATION_LANDING_PAGE =
  'FINISH_SAVE_PORTAL_QUALIFICATION_LANDING_PAGE';
export const SET_PORTAL_QUALIFICATIONS = 'SET_PORTAL_QUALIFICATIONS';
export const START_SAVE_QUALIFICATION = 'START_SAVE_QUALIFICATION';
export const FINISH_SAVE_QUALIFICATION = 'FINISH_SAVE_QUALIFICATION';
export const FINISH_CREATE_QUALIFICATION = 'FINISH_CREATE_QUALIFICATION';
export const DELETE_QUALIFICATION_FAILURE = 'DELETE_QUALIFICATION_FAILURE';
export const DELETE_QUALIFICATION_SUCCESS = 'DELETE_QUALIFICATION_SUCCESS';
export const SET_QUALIFICATION_PRICE_SUMMARY =
  'SET_QUALIFICATION_PRICE_SUMMARY';
export const SET_PORTAL_COURSES = 'SET_PORTAL_COURSES';
export const SET_PORTAL_SETTINGS = 'SET_PORTAL_SETTINGS';
export const FETCH_PORTAL_FAQS_START = 'FETCH_PORTAL_FAQS_START';
export const FETCH_PORTAL_FAQS_SUCCESS = 'FETCH_PORTAL_FAQS_SUCCESS';
export const FETCH_PORTAL_FAQS_FAILURE = 'FETCH_PORTAL_FAQS_FAILURE';
export const FETCH_PORTAL_START = 'FETCH_PORTAL_START';
export const FETCH_PORTAL_SUCCESS = 'FETCH_PORTAL_SUCCESS';
export const FETCH_PORTAL_FAILURE = 'FETCH_PORTAL_FAILURE';
export const FETCH_PORTAL_SELLING_POINTS_START =
  'FETCH_PORTAL_SELLING_POINTS_START';
export const FETCH_PORTAL_SELLING_POINTS_SUCCESS =
  'FETCH_PORTAL_SELLING_POINTS_SUCCESS';
export const FETCH_PORTAL_SELLING_POINTS_FAILURE =
  'FETCH_PORTAL_SELLING_POINTS_FAILURE';
export const FETCH_PORTAL_QUALIFICATIONS_START =
  'FETCH_PORTAL_QUALIFICATIONS_START';
export const FETCH_PORTAL_QUALIFICATIONS_SUCCESS =
  'FETCH_PORTAL_QUALIFICATIONS_SUCCESS';
export const FETCH_PORTAL_QUALIFICATIONS_FAILURE =
  'FETCH_PORTAL_QUALIFICATIONS_FAILURE';
